import { getField, updateField } from 'vuex-map-fields';
import { Quote } from '../../../models/Quote';
import { httpError } from '@/models/httpError';
import { HTTP } from '@/http-common';

const state = {
  quoteDetails: new Quote(),
  message: new httpError(),
};

//getters
const getters = {
  message: (state) => state.message,
  getField,
};

//mutations
const mutations = {
  updateField,
  setProgress(state, message) {
    state.message = message;
  },
};

//actions
const actions = {
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },

  async getQuoteDetails({ commit, dispatch, rootState }) {
    try {
      var quote = await HTTP.get(
        'order/GetQuoteDetails/' + rootState.orders.rows[0].orderID
      );

      dispatch(
        'setMessage',
        new httpError({ message: 'Retreived OK', httpStatus: 200 })
      );
      return Promise.resolve(quote.data);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'Error getting quote:' + err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },
  async saveQuoteDetail({ commit, dispatch }, payload) {
    try {
      var quote = await HTTP.post('order/SaveQuote/', payload);
      dispatch(
        'setMessage',
        new httpError({ message: 'saved OK', httpStatus: 200 })
      );
      return Promise.resolve(quote.data);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({ message: 'unable to save:' + err, httpStatus: 500 })
      );
      return Promise.reject(err);
    }
  },
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
